'use client';

import { useRouter } from 'next/navigation';
import { useState } from 'react';

export default function Home() {
  const router = useRouter();

  const [room, setRoom] = useState('');
  const [name, setName] = useState('');

  function enterRoom(e: React.FormEvent) {
    e.preventDefault();

    if (!room.trim()) return;

    router.push(`/rooms/${encodeURIComponent(room)}`);
  }

  return (
    <main
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#0f172a',
        color: 'white',
        fontFamily: 'sans-serif',
      }}
    >
      <form
        onSubmit={enterRoom}
        style={{
          width: 420,
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          padding: 40,
          borderRadius: 12,
          background: '#1e293b',
        }}
      >
        <h1 style={{ textAlign: 'center' }}>
          Campológico Meet
        </h1>

        <input
          placeholder="Nombre"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <input
          placeholder="Sala"
          value={room}
          onChange={(e) => setRoom(e.target.value)}
          required
        />

        <button type="submit">
          Entrar
        </button>
      </form>
    </main>
  );
}
